import React from 'react';
import { concatStrings, replaceUTF8Codes } from '../utilities';

const DfbHeadline = (props) => {
  var strikeClass = "";
  if (props.strike === "true") {
    strikeClass = "dfb-Headline--multiline-strikethrough";
  }
  var levelClass = "";
  if (props.noLevelClass !== "true") {
    levelClass = `dfb-Headline--${props.headline_level}`
  }
  var testid = props.testid ? props.testid : null;
  
  return (
    <props.headline_level className={concatStrings('dfb-Headline', levelClass, strikeClass, props.add_class)} data-testid={testid}>
      {replaceUTF8Codes(props.headline)}
    </props.headline_level>
  );
}
export default DfbHeadline;
